import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Link as LinkScroll } from 'react-scroll';
import ButtonBase from '../../Buttons/ButtonBase';
import './LeadsReputation.scss';

const useStyles = makeStyles({
    container: {
        justifyContent: 'center',
        width: '100%',
    },
    buttonStyle: {
        margin: '74px 0 0',
        minWidth: 293,
    }
})

const LeadsReputation = () => {

    const classes = useStyles()

    return (
        <div className='LeadsReputation'>
            <div className='LeadsReputation_container'>
                
                <p className='LeadsReputation_title'>
                    Contacta Abogado®  le ayuda construir 
                    una reputación online juntos
                </p>

                <div className='LeadsReputation_subContainer'>

                    {/* Cellphones */}
                    <div className='LeadsReputation_dataContainer LeadsReputation_column'>
                        <div className='LeadsReputation_textContainer'>
                            <p className='LeadsReputation_textContainer-title'>
                                Creación de perfil<br />profesional
                            </p>
                            <p className='LeadsReputation_textContainer-subtitle'>
                                Con toda su experiencia<br />e información curricular disponible
                            </p>
                        </div>
                        <div className='LeadsReputation_border1' />
                        <div className='LeadsReputation_imgContainer'>
                            <img
                                className='LeadsReputation_imgContainer-img1'
                                src='/img/Leads/Reputation/cellphones.png'
                                alt='cellphones'
                            />
                        </div>
                    </div>

                    {/* Computer */}
                    <div className='LeadsReputation_dataContainer LeadsReputation_column-reverse'>
                        <div className='LeadsReputation_imgContainer'>
                            <img
                                className='LeadsReputation_imgContainer-img2'
                                src='/img/Leads/Reputation/computer.png'
                                alt='computer'
                            />
                        </div>
                        <div className='LeadsReputation_border2' />
                        <div className='LeadsReputation_textContainer'>
                            <p className='LeadsReputation_textContainer-title'>
                                Posicionamiento online dentro
                                y fuera de la plataforma**
                            </p>
                            <p className='LeadsReputation_textContainer-subtitle'>
                                Nuestros especialistas en marketing digital
                                proporcionan un impulso a su perfil en
                                contactaabogado.com y los principales
                                buscadores en internet.
                            </p>
                        </div>
                    </div>

                    {/* Web page */}
                    <div className='LeadsReputation_dataContainer LeadsReputation_column'>
                        <div className='LeadsReputation_textContainer'>
                            <p className='LeadsReputation_textContainer-title'>
                                Sitio web personalizado**
                            </p>
                            <p className='LeadsReputation_textContainer-subtitle'>
                                Cuente con un sitio web con dominio personalizado.
                            </p>
                        </div>
                        <div className='LeadsReputation_border3' />
                        <div className='LeadsReputation_imgContainer'>
                            <img
                                className='LeadsReputation_imgContainer-img3'
                                src='/img/Leads/Reputation/web-page.png'
                                alt='web-page'
                            />
                        </div>
                    </div>

                    {/* Templates */}
                    <div className='LeadsReputation_dataContainer LeadsReputation_column-reverse'>
                        <div className='LeadsReputation_imgContainer'>
                            <img
                                className='LeadsReputation_imgContainer-img4'
                                src='/img/Leads/Reputation/templates.png'
                                alt='templates'
                            />
                        </div>
                        <div className='LeadsReputation_border4' />
                        <div className='LeadsReputation_textContainer'>
                            <p className='LeadsReputation_textContainer-title'>
                                Generador de propuestas comerciales**
                            </p>
                            <p className='LeadsReputation_textContainer-subtitle'>
                                Presente propuestas económicas formales a sus clientes.
                            </p>
                        </div>
                    </div>

                    {/* Tablet */}
                    <div className='LeadsReputation_dataContainer LeadsReputation_column'>
                        <div className='LeadsReputation_textContainer'>
                            <p className='LeadsReputation_textContainer-title'>
                                Publicación de<br />contenido especializado
                            </p>
                            <p className='LeadsReputation_textContainer-subtitle'>
                                Colabore con artículos y vídeos con temas
                                especializados, para que estén disponibles
                                en su perfil y redes sociales.
                            </p>
                        </div>
                        <div className='LeadsReputation_border5' />
                        <div className='LeadsReputation_imgContainer'>
                            <img
                                className='LeadsReputation_imgContainer-img5'
                                src='/img/Leads/Reputation/tablets.png'
                                alt='tablets'
                            />
                        </div>
                    </div>
                </div>
                
                <div className='LeadsReputation_buttonContainer'>
                    <LinkScroll to="leadsForm" smooth="true" duration={500} offset={-60}>
                        <ButtonBase
                            type="submit"
                            variant="secondary"
                            linkStyle={classes.linkStyle}
                            buttonStyle={classes.buttonStyle}
                        >
                            Agendar videollamada
                        </ButtonBase>
                    </LinkScroll>
                </div>

                <p className='LeadsReputation_legal'>
                    ** Para estos beneficios consulte con nuestros asesores.
                </p>
            </div>
        </div>
    )
}

export default LeadsReputation;
